import { BBox } from '@turf/helpers';
import { useKineticMap } from 'components/maps/MapContext/hooks';

import { useEffect } from 'react';

export const BoundingBox = ({ mapBounds }: { mapBounds?: BBox }) => {
  const map = useKineticMap();

  useEffect(() => {
    if (mapBounds) {
      map.fitBounds([
        [mapBounds[0], mapBounds[1]],
        [mapBounds[2], mapBounds[3]],
      ]);
    }
  }, [mapBounds, map]);

  return <></>;
};
